<script setup>
defineProps({
    content: {
        type: String,
        required: true,
    },
})
</script>

<template>
    <div
        class="content-editor"
        v-html="content"
    />
</template>
